/** 课程小节类型 */
export enum COURSE_ITEM_TYPE {
  /** 小节 */
  SESSION = 1,
  /** 章节 */
  CHAPTER = 2,
}
/** 收藏课程/小节类型 */
export enum FAVORITE_TYPE {
  COURSE = 1,
  SESSION = 2,
}

export enum RESOURCE_MEDIA_TYPE {
  /**
   * 视频
   */
  TYPE_VIDEO = 1,
  /**
   * 文档
   */
  TYPE_DOCUMENT = 2,
  /**
   * 直播流
   */
  TYPE_LIVE = 3,
  /**
   * 图文微课资源
   */
  TYPE_IMG_TEXT = 4,
  /**
   * 语音微课
   */
  TYPE_AUDIO_WEIKE = 5,
  /**
   * 封面图
   */
  TYPE_COVER_IMG = 6,
  /**
   * 富文本资源（小节的富文本说明信息）
   */
  TYPE_MULTIMEDIA_TEXT = 7,
  /**
   * 作业要求图片
   */
  TYPE_ELEMENT_IMAGE = 8,
  /**
   * 语音微课转视频
   */
  TYPE_WEIKE2VIDEO = 9,
  /**
   * 作业范例
   */
  TYPE_HOMEWORK_EXAMPLE = 10,
  /**
   * 作业多维度评价图片
   */
  TYPE_HOMEWORK_MULTI_EVAL_IMAGE = 11,
  /**
   * 会议
   */
  TYPE_MEETTING = 12,
  /**
   * ai微课
   */
  TYPE_AI_AUDIO_SLIDES = 16,
}

export enum SESSION_TYPE {
  /** 问卷  */
  SURVEY = 1,
  /** 提问  */
  ASK = 2,
  /** 讨论  */
  COMMENT = 3,
  /** 拍照  */
  PHOTO = 4,
  /** 游戏  */
  GAME = 5,
  /** 签到  */
  SIGN = 6,
  /** 语音微课  */
  MINI_COURSE = 7,
  /** 抽奖  */
  RAFFLE_DRAWING = 8,
  /** 考试  */
  EXAM = 10,
  /** 视频微课  */
  VIDEO = 11,
  /** 直播微课  */
  LIVE = 12,
  /** 文章微课  */
  ARTICLE = 13,
  /** 文档微课  */
  DOCUMENT = 14,
  /** 图文微课  */
  IMAGE_ARTICLE = 15,
  /** 作业  */
  HOMEWORK = 16,
  /** 会议  */
  MEETING = 17,
  /** 直播  */
  LIVE_PRO = 18,
  /** AI微课  */
  AI_AUDIO_SLIDES = 19,
  /** 阶段点评  */
  PHASE_EVALUATION = 20,
}

/** 课程｜小节可选操作类型 */
export enum COURSE_OPERATION_TYPE {
  SHARE_CARD = "shareCard",
  SHARE_TO_CLASS = "shareToClass",
  COPY_LINK = "copyLink",
  FAVORITE = "favorite",
}

/** 分享到班级的数据类型 */
export enum SHARE_TO_CLASS_TYPE {
  COURSE_PIC_SHARE = "101",
  COURSE = "102",
  SESSION_PIC_SHARE = "103",
  SESSION = "104",
  PROGRAM_PIC_SHARE = "105",
  PROGRAM_SHARE = "106",
  QUIZ_RANKING_PIC_SHARE = "107",
  QUIZ_RESULT_SHARE = "108",
  POINT_RANKING_PIC_SHARE = "109",
  SURVEY_RESULT_PIC_SHARE = "110",
  SURVEY_RESULT_SHARE = "111",
  LEANER_HOMEWORK = "112",
  QUIZ_RESULT_PIC_SHARE = "113",
}


export enum PARTICIPATE_STATUS {
  /**
   * 默认，没有设置开始结束时间，随时可以参与
   */
  ONBEFORE = 0,
  /**
   * 未开始
   */
  ONSTART = 1,
  /**
   * 进行中
   */
  PENDING = 2,
  /**
   * 已结束
   */
  ONEND = 3
}

/** 直播状态 */
export enum LiveStatus {
  // 'READY','ONGOING','PAUSED','FAILED','CONNECTING'
  /**
   * 已创建直播，等待开始推送直播数据
   */
  STATUS_READY = 'READY',

  /**
   * 正在直播
   */
  STATUS_ONGOING = 'ONGOING',

  /**
   * 直播暂停（本次不支持暂停，只要暂停就认为结束）
   */
  STATUS_PAUSED = 'PAUSED',

  /**
   * 异常情况
   */
  STATUS_FAILED = 'FAILED',

  /**
   * 有状态，但文档中没有使用过，忽略
   */
  STATUS_CONNECTING = 'CONNECTING',
};

/** 排行榜类型 */
export enum ERankType {
  /** 积分 */
  POINTS = '1',
  /** 达成 */
  COMPLETION = '2',
  /** 卓越 */
  EXCELLENCE = '3',
  /** 积极 */
  ENGAGEMENT = '4',
  /** 认可 */
  RECOGNITION = '5',
}

export enum ELiveType {
  VIDEO = "1",
  AUDIO_ONLY = "2"
}
export enum EMEETING_STATUS {
  NOT_STARTED = "0",
  ONGOING = "1",
  END = "2"
}

/** 媒体小节标签样式 */
export enum EMediaStatusStyleType {
  DEFAULT = 0,
  RED = 1,
}

export enum EHomeworkType {
  /**
   * 音频作业
   */
  AUDIO = "1",
  /**
   * 视频作业
   */
  VIDEO = "2",
  /**
   * 图文作业
   */
  IMGTXT = "3",
  /**
   * 文档作业
   */
  DOC = "4",
  /**
   * 动作练习
   */
  GESTURE = "5"
}

export enum ELearnStatus {
  /** 未学习 */
  notLearn = 0,
  /** 学习中 */
  learning = 1,
  /** 已学完 */
  learned = 2,
}
export enum EUserSetupType {
  /** 课程排序 */
  SESSION_SORT = 3
}